/// <amd-module name="Build/SourceProviders/TraceNames" />
export const area = 'vss-build-web.common.sourceproviders';
